import React, { useEffect, useState } from "react";
import { Search, Wifi, WifiOff } from "lucide-react";
import { useEntity } from "@/lib/entity";
import { useRealtime } from "@/lib/realtime";
import NotificationsBell from "@/components/NotificationsBell";

export default function Topbar({ title, onOpenSearch }) {
  const { currentEntity } = useEntity();
  const { connected } = useRealtime();
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 30000);
    return () => clearInterval(t);
  }, []);

  const dateStr = now.toLocaleDateString("fr-FR", { weekday: "long", day: "numeric", month: "long", year: "numeric" });

  return (
    <header className="fixed top-0 left-sidebar right-0 h-topbar bg-obsidian-950/95 backdrop-blur-md border-b border-line z-20 flex items-center px-6 gap-4" data-testid="app-topbar">
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 text-[11px] font-mono text-obsidian-400 uppercase tracking-wider">
          <span className="w-1.5 h-1.5 rounded-full bg-citron animate-pulse-glow" />
          <span>Espace Direction</span>
          <span className="text-obsidian-600">/</span>
          <span style={{ color: currentEntity?.color }}>{currentEntity?.name}</span>
        </div>
        {title && <h1 className="font-heading text-xl font-bold tracking-tight leading-tight mt-0.5 truncate">{title}</h1>}
      </div>

      <button
        onClick={onOpenSearch}
        className="hidden md:flex items-center gap-2 px-3 h-9 bg-obsidian-900 border border-line rounded-sm text-sm text-obsidian-400 hover:text-obsidian-50 hover:border-obsidian-700 transition-colors"
        data-testid="topbar-search-button"
      >
        <Search size={14} />
        <span>Rechercher…</span>
        <kbd className="ml-4 text-[10px] font-mono px-1.5 py-0.5 bg-obsidian-800 rounded">⌘K</kbd>
      </button>

      <div className="hidden lg:flex items-center gap-4 text-[11px] font-mono text-obsidian-400">
        <span className="capitalize">{dateStr}</span>
        <span className="text-obsidian-700">·</span>
        <span className={`inline-flex items-center gap-1 ${connected ? "text-ok" : "text-warn"}`} title={connected ? "Temps réel connecté" : "Reconnexion…"}>
          {connected ? <Wifi size={12} /> : <WifiOff size={12} />} {connected ? "Live" : "Hors ligne"}
        </span>
      </div>

      <NotificationsBell />
    </header>
  );
}
